import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'
import { composeStyle } from '@xhs/yam-beer/core/system/compose'

const disabledState = '&[disabled]'
const hoverState = '&:not([disabled]):hover, &:not([disabled])[data-hover="true"]'
const activeState = '&:not([disabled]):active, &:not([disabled])[active]'

const baseStyle = {
  WebkitFontSmoothing: 'antialiased',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  verticalAlign: 'middle',
  textDecoration: 'none',
  border: 'none',
  outline: 'none',
  userSelect: 'none',
  p: 0,
  cursor: 'pointer',
  '&::-moz-focus-inner ': {
    border: 0,
  },
  [disabledState]: {
    cursor: 'not-allowed',
  },
}

export default function initStyle() {
  return [
    registerThemeSpec('cmp.button.base', {
      default: {
        ...baseStyle,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        mr: '2x',
        paddingBottom: 0,
        paddingTop: 0,
        borderRadius: 'button',
      },
      content: {
        display: 'inline-block',
        // textOverflow: 'ellipsis',
        // overflowX: 'hidden',
        // whiteSpace: 'nowrap',
      },
    }),
    registerThemeSpec(
      'cmp.button.size',
      composeStyle.switch('size')
        .case('nss', {
          fontSize: '12px',
        })
        .case('nm', {
          fontSize: '14px',
        })
        .case('m', {
          px: 16,
          minWidth: 88,
          height: 32,
          fontSize: '14px',
        })
        .case('l', {
          minWidth: 96,
          px: 16,
          height: 40,
          fontSize: '16px',
        })
        .case('s', {
          minWidth: 80,
          px: 12,
          height: 28,
          fontSize: '14px',
        }),
    ),
    registerThemeSpec(
      'cmp.button.variant',
      composeStyle.switch('variant')
        .case('secondary', composeStyle.var('modifier', {
          color: 'body',
          fill: 'body',
          bg: 'white',
          border: 'outlineoutline',
          [disabledState]: {
            color: 'palette.body.disable',
            borderColor: 'palette.outline.disable',
            fill: 'palette.body.disable',
          },
          [hoverState]: {
            color: 'palette._VAR_.hover',
            borderColor: 'palette._VAR_.hover',
            fill: 'palette._VAR_.hover',
          },
          [activeState]: {
            color: 'palette._VAR_.active',
            fill: 'palette._VAR_.active',
            borderColor: 'palette._VAR_.active',
          },
        }))
        .case('outline', composeStyle.var('modifier', {
          color: '_VAR_',
          fill: '_VAR_',
          bg: 'white',
          border: '_VAR_outline',
          [disabledState]: {
            color: 'palette._VAR_.disable',
            fill: 'palette._VAR_.disable',
            borderColor: 'palette._VAR_.disable',
          },
          [hoverState]: {
            color: 'palette._VAR_.hover',
            fill: 'palette._VAR_.hover',
            borderColor: 'palette._VAR_.hover',
          },
          [activeState]: {
            color: 'palette._VAR_.active',
            fill: 'palette._VAR_.active',
            borderColor: 'palette._VAR_.active',
          },
        }))
        .case('link', {
          bg: 'unset', // safari support ...
          fill: 'brand',
        })
        .case('default', composeStyle.var('modifier', {
          border: '1px solid transparent',
          bg: 'palette._VAR_.base',
          color: 'white',
          fill: 'white',
          [disabledState]: {
            bg: 'palette._VAR_.disable',
          },
          [hoverState]: {
            bg: 'palette._VAR_.hover',
          },
          [activeState]: {
            bg: 'palette._VAR_.active',
          },
        }))
        .case('text', composeStyle.var('modifier', {
          color: 'body',
          bg: 'transparent',
          fill: 'body',
          [disabledState]: {
            color: 'palette._VAR_.disable',
            fill: 'palette._VAR_.disable',
          },
          [hoverState]: {
            fill: 'palette._VAR_.hover',
            color: 'palette._VAR_.hover',
          },
          [activeState]: {
            color: 'palette._VAR_.active',
            fill: 'palette._VAR_.active',
          },
        }))
        .case('stroke', composeStyle.var('modifier', {
          color: '_VAR_',
          bg: 'transparent',
          fill: '_VAR_',
          [disabledState]: {
            color: 'palette._VAR_.disable',
            fill: 'palette._VAR_.disable',
          },
          [hoverState]: {
            fill: 'palette._VAR_.hover',
            color: 'palette._VAR_.hover',
          },
          [activeState]: {
            color: 'palette._VAR_.active',
            fill: 'palette._VAR_.active',
          },
        })),
    ),
  ]
}
